import { render, staticRenderFns } from "./mForm.vue?vue&type=template&id=267496fb&"
import script from "./mForm.vue?vue&type=script&lang=js&"
export * from "./mForm.vue?vue&type=script&lang=js&"
import style0 from "./mForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports